<template>
  <div>
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>

          <b-form>
            <b-form-group
              label="Fecha Comprobante"
              label-for="fechaComprobante"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaComprobante" 
                v-model="fechaComprobante" 
                type="date">
              </b-form-input>
            </b-form-group>

            <app-retencion-tipo
              label="Tipo"
              :nombre="retencionTipoNombre"
              :lista="retencionesTiposList"
              :labelCols="labelCols"
              :valido="retencionTipoValido"
              :msjInvalido="retencionTipoInvalidoMsj"
              @updated="retencionTipoActualizado">
            </app-retencion-tipo>

            <app-retencion-regimen
              label="Regimen"
              :nombre="retencionRegimenNombre"
              :lista="retencionesRegimenesList"
              :labelCols="labelCols"
              :valido="retencionRegimenValido"
              :msjInvalido="retencionRegimenInvalidoMsj"
              @updated="retencionRegimenActualizado">
            </app-retencion-regimen>

            <app-retencion-jurisdiccion
              label="Jurisdiccion"
              :nombre="jurisdiccionIngresosBrutosNombre"
              :lista="jurisdiccionesList"
              :labelCols="labelCols"
              :disabled="!jurisdiccionHabilitada"
              :valido="jurisdiccionValida"
              :msjInvalido="jurisdiccionInvalidaMsj"
              @updated="jurisdiccionActualizada">
            </app-retencion-jurisdiccion>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RetencionTipo from '../shared/abmSelect.vue';
import RetencionRegimen from '../shared/abmSelect.vue';
import RetencionJurisdiccion from '../shared/abmSelect.vue';
import { required, requiredIf, numeric, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'retencioncliente/getField',
  mutationType: 'retencioncliente/updateField',
});

export default {
  name: 'ABM',
  props: {
  },
  components: {
    appRetencionTipo: RetencionTipo,
    appRetencionRegimen: RetencionRegimen,
    appRetencionJurisdiccion: RetencionJurisdiccion
  },
  data () {
    return {
      noValidar: true,
      retencionTipoValido: null,
      retencionTipoInvalidoMsj: '',
      retencionRegimenValido: null,
      retencionRegimenInvalidoMsj: '',
      jurisdiccionValida: null,
      jurisdiccionInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',

      retencionesTipos: [],
      retencionesTiposList: [],
      retencionesRegimenes: [],
      retencionesRegimenesList: [],
      jurisdicciones: [],
      jurisdiccionesList: [],
      jurisdiccionHabilitada: false,

      labelCols: 3,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: ''
    }
  },
  computed: {
    ...mapFields([
      'fechaComprobante',
      'retencionTipo',
      'retencionTipoNombre',
      'retencionRegimen',
      'retencionRegimenNombre',
      'jurisdiccionIngresosBrutos',
      'jurisdiccionIngresosBrutosNombre',
      'importe',
    ])
  },  
  created() {
    this.$store.dispatch('retencioncliente/inicializar')
      .then(() => {
        this.getDatosAdicionales();
      }, error => {
        this.alertMsj = error;
        this.alertVariant = "danger";
        this.alertCountDown = 15;
        this.showAlert();
      })
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this

      vm.$store.dispatch('retencionestipos/getList')
        .then(() => {
          vm.retencionesTipos = this.$store.getters['retencionestipos/list'];
          vm.retencionesTiposList = this.$store.getters['retencionestipos/selectList'];

          vm.retencionesRegimenes = [];
          vm.retencionesRegimenesList = [];
        })
        .catch(error => {
          this.alertMsj = "Se produjo un error al recuperar la lista de tipos de retención.";
          this.alertVariant = "danger";
          this.alertCountDown = 15;
          this.showAlert();
        });

      vm.$store.dispatch('jurisdiccionesIngresosBrutos/getList')
        .then(() => {
          vm.jurisdicciones = this.$store.getters['jurisdiccionesIngresosBrutos/list'];
          vm.jurisdiccionesList = this.$store.getters['jurisdiccionesIngresosBrutos/selectList'];
        })
        .catch(() => {
          this.alertMsj = "Se produjo un error al recuperar la lista de jurisdicciones.";
          this.alertVariant = "danger";
          this.alertCountDown = 15;
          this.showAlert();
        });
    },
    getRegimenes() {
      this.retencionRegimenNombre = null;      
      this.retencionesRegimenes = [];
      this.retencionesRegimenesList = [];

      let retencionTipo = null;
      if (this.retencionTipoNombre) {
        retencionTipo = this.getSelected(this.retencionesTipos, this.retencionTipoNombre);
      }
      if (retencionTipo) {
        if (retencionTipo.id != 0) {
          this.$store.dispatch('retencionesregimenes/getList', retencionTipo.id)
            .then(() => {
                this.retencionesRegimenes = this.$store.getters['retencionesregimenes/list']
                this.retencionesRegimenesList = this.$store.getters['retencionesregimenes/selectList']
              })
              .catch(error => {
                this.alertMsj = "Se produjo un error al recuperar la información de regimenes de retención.";
                this.alertVariant = "danger";
                this.alertCountDown = 15;
                this.showAlert();              
              })
        }
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe de la retencion debe ser un valor numérico';
          } else if (!this.$v.importe.minValue) {
              this.importeInvalidoMsj = 'El importe de la retencion no es válido';
          }     
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      let retencionTipoError = true;
      let retencionTipo = null;
      if (this.retencionTipoNombre) {
        retencionTipo = this.getSelected(this.retencionesTipos, this.retencionTipoNombre);
      }
      this.$store.dispatch('retencioncliente/setRetencionTipo', retencionTipo);

      if (this.retencionTipo) {
        if (this.retencionTipo.id != 0){
          retencionTipoError = false;
        }
      }
      if (retencionTipoError) {
        save = false;
        this.retencionTipoValido = false;
        this.retencionTipoInvalidoMsj = "Debe seleccionar el tipo de retención correspondiente."
      }

      if (this.retencionesRegimenes.length != 0) {
        let retencionRegimenError = true;
        let retencionRegimen = null;
        if (this.retencionRegimenNombre) {
          retencionRegimen = this.getSelected(this.retencionesRegimenes, this.retencionRegimenNombre);
        }
        this.$store.dispatch('retencioncliente/setRetencionRegimen', retencionRegimen);

        if (this.retencionRegimen) {
          if (this.retencionRegimen.id != 0){
            retencionRegimenError = false;
          }
        }
        if (retencionRegimenError) {
          save = false;
          this.retencionRegimenValido = false;
          this.retencionRegimenInvalidoMsj = "Debe seleccionar el regimen de retención correspondiente."
        }
      }



      let jurisdiccionError = true;
      let jurisdiccionIngresosBrutos = null;
      if (this.jurisdiccionIngresosBrutosNombre) {
        jurisdiccionIngresosBrutos = this.getSelected(this.jurisdicciones, this.jurisdiccionIngresosBrutosNombre);
      }
      this.$store.dispatch('retencioncliente/setJurisdiccion', jurisdiccionIngresosBrutos);

      if (this.retencionTipo) {
        if ((/true/i).test(this.retencionTipo.requiereJurisdiccion)) {
          if (this.jurisdiccionIngresosBrutos) {
            if (this.jurisdiccionIngresosBrutos.id != 0){
              jurisdiccionError = false;
            }
          }
          if (jurisdiccionError) {
            save = false;
            this.jurisdiccionValida = false;
            this.jurisdiccionInvalidaMsj = "Debe seleccionar la jurisdiccion correspondiente."
          }
        }
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.$emit('retencionClienteAgregada', 
            this.$store.getters['retencioncliente/retencionCliente']);
        } 
      }
    },
    retencionTipoActualizado(nombre) {
      this.retencionTipoNombre = nombre;

      let retencionTipo = null;
      if (this.retencionTipoNombre) {
        retencionTipo = this.getSelected(this.retencionesTipos, this.retencionTipoNombre);
      }
      this.$store.dispatch('retencioncliente/setRetencionTipo', retencionTipo);

      /* Verificamos si debe seleccionar jurisdicción */
      this.jurisdiccionHabilitada = false;
      this.jurisdiccionIngresosBrutosNombre = null;
      this.jurisdiccionValida = null;
      this.jurisdiccionInvalidaMsj = '';

      if (this.retencionTipo) {
        this.jurisdiccionHabilitada = (/true/i).test(this.retencionTipo.requiereJurisdiccion);

        this.retencionTipoValido = null;
        this.retencionTipoInvalidoMsj = '';

        this.getRegimenes();
        this.retencionRegimenValido = null;
        this.retencionRegimenInvalidoMsj = '';
      }
    },
    retencionRegimenActualizado(nombre) {
      this.retencionRegimenNombre = nombre;

      if (this.retencionRegimenNombre ) {
        this.retencionRegimenValido = null;
        this.retencionRegimenInvalidoMsj = '';
      }
    },
    jurisdiccionActualizada(nombre) {
      this.jurisdiccionIngresosBrutosNombre = nombre;

      if (this.jurisdiccionIngresosBrutosNombre ) {
        this.jurisdiccionValida = null;
        this.jurisdiccionInvalidaMsj = '';
      }
    },
    goBack() {
      this.$emit('cancel');
    }
  },
  watch: {
    /*
    'provinciaNombre' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loadingProvincias) {
        this.localidadNombre = null;
        this.getLocalidades();
      }
    },
    'condicionFiscalNombre': function(newVal, oldVal) {
      if ( newVal != oldVal) {
        if (newVal) {
          this.condicionFiscalValida = null;
          this.condicionFiscalInvalidaMsj = '';
        }
      }
    },
    */
  },
  validations: {
    importe: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
</style>
